import React from "react";

// Goal timing heatmap by 15-min interval
export const Heatmap = ({ intervals, home, away, homeShort, awayShort }) => {
  const max = Math.max(1, ...home, ...away);
  const cell = (v, base) => {
    const intensity = v / max;
    return {
      background: `rgba(${base}, ${0.12 + intensity * 0.85})`,
      boxShadow: intensity > 0.7 ? `0 0 12px rgba(${base},0.5)` : "none",
    };
  };
  const Row = ({ label, data, base }) => (
    <div className="flex items-center gap-2">
      <span className="w-12 text-[10px] font-bold uppercase tracking-wider text-white/50">{label}</span>
      <div className="grid grid-cols-6 gap-1.5 flex-1">
        {data.map((v, i) => (
          <div
            key={i}
            className="h-11 rounded-md flex items-center justify-center font-numeral font-bold text-sm"
            style={cell(v, base)}
            data-testid={`heat-${label}-${i}`}
          >
            {v > 0 ? v : ""}
          </div>
        ))}
      </div>
    </div>
  );
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <span className="w-12" />
        <div className="grid grid-cols-6 gap-1.5 flex-1">
          {intervals.map((iv) => (
            <span key={iv} className="text-center text-[9px] font-semibold text-white/40">{iv}'</span>
          ))}
        </div>
      </div>
      <Row label={homeShort} data={home} base="212,175,55" />
      <Row label={awayShort} data={away} base="47,174,224" />
    </div>
  );
};
